<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-03-21 11:34:22
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-16 11:12:40
 * @FilePath: /jy-dashboard-web/src/App.vue
 * @Description: 路由入口
-->
<template>
  <router-view/>
</template>

<script>
export default {}
</script>

<style lang="scss">
#app {
  height: 100%;
}
</style>
